import { render, staticRenderFns } from "./metrics_assignment_summary.vue?vue&type=template&id=6c2eaf49&scoped=true&"
import script from "./metrics_assignment_summary.vue?vue&type=script&lang=js&"
export * from "./metrics_assignment_summary.vue?vue&type=script&lang=js&"
import style0 from "./metrics_assignment_summary.vue?vue&type=style&index=0&id=6c2eaf49&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2eaf49",
  null
  
)

export default component.exports